module.exports = __webpack_public_path__ + "media/images/escape_to_school_ef_link/wording-sp-9f6a27abd1243cac0920f3de3d59caff.svg";